<!--BUTTON VARIANT SWITCH-->
@switch (variant()) {
	@case ("flat") {
		<button
			(click)="buttonClicked()"
			[autofocus]="false"
			[color]="color()"
			[disableRipple]="true"
			[disabled]="disabled()"
			[ngClass]="size()"
			mat-flat-button
		>
			@if (isAnimated()) {
				<span class="innerWrapper">
					<sim-animated-material-icon [endIcon]="animation().icon" [startIcon]="icon()" [trigger]="animation().trigger" />
					<label>
						{{ label() | translate }}
					</label>
				</span>
			} @else {
				<span class="innerWrapper">
					<mat-icon
						class="staticIcon"
						[@zoomInOnEnter]
						[@zoomOutOnLeave]
						[fontIcon]="icon().fontIcon"
						[fontSet]="icon().fontSet"
						inline
					/>
					<i class="busyIcon fad fa-spinner fa-pulse"></i>
					<label>
						{{ label() | translate }}
					</label>
				</span>
			}
		</button>
	}
	@case ("raised") {
		<button
			(click)="buttonClicked()"
			[autofocus]="false"
			[color]="color()"
			[disableRipple]="true"
			[disabled]="disabled()"
			[ngClass]="size()"
			mat-raised-button
		>
			@if (isAnimated()) {
				<span class="innerWrapper">
					<sim-animated-material-icon [endIcon]="animation().icon" [startIcon]="icon()" [trigger]="animation().trigger" />
					<label>
						{{ label() | translate }}
					</label>
				</span>
			} @else {
				<span class="innerWrapper">
					<mat-icon
						class="staticIcon"
						[@zoomInOnEnter]
						[@zoomOutOnLeave]
						[fontIcon]="icon().fontIcon"
						[fontSet]="icon().fontSet"
						inline
					/>
					<i class="busyIcon fad fa-spinner fa-pulse"></i>
					<label>
						{{ label() | translate }}
					</label>
				</span>
			}
		</button>
	}
	@case ("stroked") {
		<button
			(click)="buttonClicked()"
			[autofocus]="false"
			[color]="color()"
			[disableRipple]="true"
			[disabled]="disabled()"
			[ngClass]="size()"
			mat-stroked-button
		>
			@if (isAnimated()) {
				<span class="innerWrapper">
					<sim-animated-material-icon [endIcon]="animation().icon" [startIcon]="icon()" [trigger]="animation().trigger" />
					<label>
						{{ label() | translate }}
					</label>
				</span>
			} @else {
				<span class="innerWrapper">
					<mat-icon
						class="staticIcon"
						[@zoomInOnEnter]
						[@zoomOutOnLeave]
						[fontIcon]="icon().fontIcon"
						[fontSet]="icon().fontSet"
						inline
					/>
					<i class="busyIcon fad fa-spinner fa-pulse"></i>
					<label>
						{{ label() | translate }}
					</label>
				</span>
			}
		</button>
	}
	@case ("basic") {
		<button
			(click)="buttonClicked()"
			[autofocus]="false"
			[color]="color()"
			[disableRipple]="true"
			[disabled]="disabled()"
			[ngClass]="size()"
			mat-button
		>
			@if (isAnimated()) {
				<span class="innerWrapper">
					<sim-animated-material-icon [endIcon]="animation().icon" [startIcon]="icon()" [trigger]="animation().trigger" />
					<label>
						{{ label() | translate }}
					</label>
				</span>
			} @else {
				<span class="innerWrapper">
					<mat-icon
						class="staticIcon"
						[@zoomInOnEnter]
						[@zoomOutOnLeave]
						[fontIcon]="icon().fontIcon"
						[fontSet]="icon().fontSet"
						inline
					/>
					<i class="busyIcon fad fa-spinner fa-pulse"></i>
					<label>
						{{ label() | translate }}
					</label>
				</span>
			}
		</button>
	}
}

<!--ICON TEMPLATES-->
